import React from "react";
import {createContext} from "react";
import useSpectrumProps from "./useSpectrumProps";


const SpectrumContext = createContext({});


const SpectrumProvider = ({ children }) => {
  const value = useSpectrumProps({
    lineHeight: 32,
  });

  return (
    <SpectrumContext.Provider value={value}>
      {children}
    </SpectrumContext.Provider>
  )
};


const { Consumer: SpectrumConsumer } = SpectrumContext;

export { SpectrumProvider, SpectrumConsumer };

export default SpectrumContext;
